<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-propriedade') {
            next({ name: 'agro-propriedade-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-propriedade') {
            this.$router.push({ name: 'agro-propriedade-list' });
        }
    },
};
</script>
